export default __webpack_public_path__ + "media/gallery/maxmara-a769f057.jpg";